// @ts-check

import ResetGridLink from '~/components/Shared/DataGrid/ResetGridLink';
import { useAssignmentDataGridContext } from '~/components/Forms/AssignmentDataGrid/AssignmentDataGrid.context';
import { DEFAULT_SORT_MODEL, EventNames } from '~/components/Forms/AssignmentDataGrid/AssignmentDataGrid.utils';

export default function ResetAssignmentGridLink() {
    const { settings } = useAssignmentDataGridContext();

    return (
        <ResetGridLink
            settings={settings}
            resetTableEventName={EventNames.RESET_TABLE}
            defaultSortModel={DEFAULT_SORT_MODEL}            
        />
    );
}
